<template>
  <div class="room-filter tw-relative tw-flex tw-items-center">
    <button
      class="tw-rounded-full hover:tw-bg-slate-200"
      @click="onOpenFilterBox"
    >
      <svg
        class="tw-w-6 tw-h-6 tw-fill-slate-500"
        xmlns="http://www.w3.org/2000/svg"
        enable-background="new 0 0 24 24"
        viewBox="0 0 24 24"
      >
        <g>
          <path d="M0,0h24 M24,24H0" fill="none" />
          <path
            d="M7,6h10l-5.01,6.3L7,6z M4.25,5.61C6.27,8.2,10,13,10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-6 c0,0,3.72-4.8,5.74-7.39C20.25,4.95,19.78,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z"
          />
          <path d="M0,0h24v24H0V0z" fill="none" />
        </g>
      </svg>
    </button>
    <Transition>
      <div
        v-if="showFilterBox"
        v-click-outside="outside"
        class="tw-absolute tw-top-0 tw-left-0 tw-bg-white tw-shadow-xl tw-drop-shadow-xl tw-rounded-sm tw-z-10 tw-text-left tw-p-2 tw-text-sm tw-w-64 tw-space-y-2"
      >
        <div class="tw-flex tw-justify-center">
          <p class="tw-font-bold">Room filters</p>
        </div>
        <div class="tw-flex tw-justify-between">
          <p class="tw-font-bold">Room status</p>
          <button @click="filterStatusCheckbox = []" class="tw-text-primary">
            Clear
          </button>
        </div>
        <div
          class="options tw-h-auto tw-flex tw-flex-col tw-overflow-auto tw-space-y-1"
        >
          <div
            v-for="status in roomStatus"
            :key="status.status"
            class="tw-flex tw-gap-2"
          >
            <input
              type="checkbox"
              class="tw-text-primary border-0 focus:ring-0"
              :id="status.status"
              :value="status.status"
              v-model="filterStatusCheckbox"
            />
            <label class="tw-whitespace-nowrap" :for="status.status">
              {{ status.title }}
            </label>
          </div>
        </div>
        <div class="tw-flex tw-justify-between">
          <p class="tw-font-bold">Tags</p>
          <button @click="filterTagCheckbox = []" class="tw-text-primary">
            Clear
          </button>
        </div>
        <input
          type="text"
          placeholder="Select one or more options..."
          class="tw-p-1 tw-border tw-rounded-sm tw-w-full"
          v-model="filterOptionInput"
        />
        <div
          class="options tw-h-48 tw-flex tw-flex-col tw-overflow-auto tw-space-y-1"
        >
          <div
            v-for="option in filteredTags"
            :key="`${option.Title} + ${option.Type}`"
            class="tw-flex tw-gap-2"
          >
            <input
              type="checkbox"
              class="tw-text-primary border-0 focus:ring-0"
              :id="option.Title"
              :value="option"
              v-model="filterTagCheckbox"
            />
            <label class="tw-whitespace-nowrap" :for="option.Title">
              <room-card-tag :tag="option"></room-card-tag>
            </label>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "RoomFilter",
  props: {
    value: Object,
  },
  components: {
    RoomCardTag: () => import("@/ui/components/chat/RoomCardTag.vue"),
  },
  data() {
    return {
      isDisable: true,
      showFilterBox: false,
      filterOptionInput: "",
      filterTagCheckbox: [],
      filterStatusCheckbox: [],
      roomStatus: [
        { title: "Open", status: "opened" },
        { title: "Close", status: "closed" },
        { title: "Pending reply", status: "abandon" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      tags: "chat/tags",
    }),
    filteredTags() {
      let list = this.tags;
      if (this.filterOptionInput) {
        list = list.filter(
          (l) =>
            l.Title.toLowerCase().search(
              this.filterOptionInput.toLowerCase()
            ) !== -1
        );
      }
      return list;
    },
  },
  watch: {
    filterTagCheckbox() {
      this.updateValue();
    },
    filterStatusCheckbox() {
      this.updateValue();
    },
    showFilterBox: async function (value) {
      if (value) {
        await this.$store.dispatch("chat/listTags");
      }
    },
  },
  methods: {
    onOpenFilterBox() {
      this.showFilterBox = !this.showFilterBox;
      setTimeout(() => {
        this.isDisable = false;
      }, 100);
    },
    updateValue() {
      this.$emit("input", {
        status: this.filterStatusCheckbox,
        tags: this.filterTagCheckbox,
      });
    },
    outside: function () {
      console.log("outside", this.showFilterBox);
      if (this.isDisable) {
        return;
      }
      if (this.showFilterBox) {
        this.showFilterBox = false;
      }
      this.isDisable = true;
    },
  },
  directives: {
    "click-outside": {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function (el) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
};
</script>

<style>

</style>
